module.exports = __webpack_public_path__ + "img/4.67ef3320.jpg";